<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <div
          class="font-weight-medium ml-5"
          style="font-size: 20px"
        >
          Flow Strategy
        </div>
      </v-col>
    </v-row>
      
    <v-card height='100%'>
      <v-container fluid class="pa-5">
        <v-form @submit="getStockList">
          <v-row>
            <v-col cols="12">
              <p>PARAMETERS - Select the parameters of your strategy</p>

            </v-col>
          </v-row>
          <v-row>                        
            <v-col cols="12" md="6" lg="4">
              <v-subheader class="pl-0">Number of stocks</v-subheader>
              <v-slider
                v-model="nbStocks"
                thumb-label="always"
                min="10"
                max="100"                
              ></v-slider>
            </v-col>
          </v-row>
          <v-row>               
            <v-col
              cols="12"
              md="4"
            >
              <v-select
                v-model="sector"
                :items="sectors"
                item-text="sector"
                item-value="code"                
                label="Sector"
                multiple
                chips
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @click="toggleAllSector"
                  >
                    <v-list-item-action>
                      <v-icon :color="sector.length > 0 ? 'indigo darken-4' : ''">{{ iconSector }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Select All</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>              
     
              </v-select>


            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-select
                v-model="country"
                :items="countries"
                item-text="country"
                item-value="country"                     
                label="Country"
                multiple
                chips
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @click="toggleAllCountry"
                  >
                    <v-list-item-action>
                      <v-icon :color="country.length > 0 ? 'indigo darken-4' : ''">{{ iconCountry }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Select All</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>           
              </v-select>
            </v-col>

          </v-row>
          <v-row>
            <v-col cols="12">
              <p>PERIOD - Select period and benchmark to display</p>

            </v-col>

            <v-col cols="12" sm="6" md="3">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateStart"
                    label="Start date"
                    prepend-icon="mdi-calendar-blank"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateStart" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-menu
                v-model="menu3"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateEnd"
                    label="End date"
                    prepend-icon="mdi-calendar-blank"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateEnd" @input="menu3 = false"></v-date-picker>
              </v-menu>
            </v-col>   
          </v-row>         
          <v-row>         
            <v-col
              cols="12"
              md="4"
            >
              <v-select
                v-model="benchmark"
                :items="benchmarks"
                item-text="name"
                item-value="id"                     
                label="Benchmark"
              >                
              </v-select>
            </v-col>
          
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
            </v-col>
            <v-col
              cols="12"
              class="text-right"
            >
              <v-btn
                color="primary"
                class="mr-3"
                type="submit"
                
                :loading="buttonLoading"
              >
                Compute Strat
              </v-btn>
              <v-btn
                color="primary"
                outlined
                class="mr-0"
                @click="resetSearchForm()"
              >
                Reset
              </v-btn>
            </v-col>
          </v-row>                    
        </v-form>
      </v-container>
    </v-card>
    <v-row>
      <v-col>
        <p>Strategy Results</p>
      </v-col>      
    </v-row>
    
    <v-row :align="'stretch'">
      
      <v-overlay
        :absolute="absolute"
        :opacity="opacity"
        :value="overlay"
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>                  
      <v-col cols="12" lg ="6" >
        <v-card class="mt-5 height: 100%;">
          <v-container fluid class="pa-5">


            <v-row>
              <v-col cols="12">
                <p>PERFORMANCE</p>
              </v-col>
            </v-row>
            <v-row>                    
              <v-col cols="12">
                <v-skeleton-loader v-if="listLoad" type="card" :height="250"></v-skeleton-loader>       
                <strategy-performance-chart v-if="!listLoad" :chartData="stratReturn" :height="250" > </strategy-performance-chart>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col> 
      <v-col cols="12" lg ="6" >
        <v-card class="mt-5 height: 100%;">
          <v-container fluid class="pa-5 height: 100%;">
            <v-row>
              <v-col cols="12">
                <p>TABLE PERF</p>
              </v-col>
            </v-row>
            <v-row>                    
              <v-col cols="12">
                <v-skeleton-loader v-if="listLoad" type="table"></v-skeleton-loader>
                <v-simple-table v-if="!listLoad">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left"></th>
                        <th class="text-right">Strategy</th>
                        <th class="text-right">Benchmark (USD)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in stats" :key="i">
                      
                        <td>{{ item.year }}</td>
                        <td class="text-right">{{ item.daily_return  | numeral('0.[0]%')}}</td>
                        <td class="text-right">{{ item.price  | numeral('0.[0]%') }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>             
    </v-row>  
    <v-row>
      <v-col cols="12" lg ="6" >
        <v-card class="mt-5" height='100%'>
          <v-container fluid class="pa-5">


            <v-row>
              <v-col cols="12">
                <p>COUNTRY ROLLING EXPO</p>
              </v-col>
            </v-row>
            <v-row>                    
              <v-col cols="12">
                <v-skeleton-loader v-if="listLoad" type="card" :height="250"></v-skeleton-loader>       
                <rolling-expo-chart v-if="!listLoad" :chartData="countryExpo" :height="250" > </rolling-expo-chart>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col> 
      <v-col cols="12" lg ="6" >
        <v-card class="mt-5" height='100%'>
          <v-container fluid class="pa-5">


            <v-row>
              <v-col cols="12">
                <p>SECTOR ROLLING EXPO </p>
              </v-col>
            </v-row>
            <v-row>                    
              <v-col cols="12">
                <v-skeleton-loader v-if="listLoad" type="card" :height="250"></v-skeleton-loader>       
                <rolling-expo-chart v-if="!listLoad" :chartData="sectorExpo" :height="250" > </rolling-expo-chart>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>             
    </v-row>  
    <v-row>
      <v-col cols="12"  >
        <v-card class="mt-5" height='100%'>
          <v-container fluid class="pa-5">

            <v-row>
              <v-col cols="12">
                <p>CONSTITUENTS</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" md="4">            
                  <v-select
                    label ="Constituents date"
                    v-model="portfolioConstituentsDate"
                    :items="portfolioListRebal"
                    v-on:change="updatePortfolioConstituentsAtDate"
                  ></v-select>
              </v-col>          
            </v-row>              
            <v-row>                    
              <v-col cols="12">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Filter"
                  single-line
                  hide-details
                  style="max-width: 250px;"
                  class="float-right"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-overlay
                  :absolute="absolute"
                  :opacity="opacity"
                  :value="overlay2"
                >
                  <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>            
                <v-skeleton-loader v-if="listLoad" type="table"></v-skeleton-loader>
                <v-data-table
                  v-show="!listLoad"
                  :headers="headers"
                  :items="portfolioConstituents"
                  :search.sync="search"
                  :mobile-breakpoint="0"
                >
                  <template v-slot:item="row">
                    <tr>
                      <td>
                        <v-btn
                          class="px-2 mr-2"
                          color="primary"
                          min-width="0"
                          icon
                          small
                          @click="analyzeStock(row.item.ric)"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on">
                                mdi-magnify-plus-outline
                              </v-icon>                        
                            </template>
                            <span>Analyze</span>
                          </v-tooltip> 
                        </v-btn>
                      </td>
                      <td>{{ row.item.name }}</td>
                      <td>{{ row.item.ticker }}</td>
                      <td>{{ row.item.ric }}</td>
                      <td class="text-right">
                        <span class="px-4">
                          {{ row.item.wgt | numeral('0.[0]%') }}
                         </span>
                      </td>
                      <td class="text-right">{{ row.item.sector }}</td>
                      <td class="text-center">{{ row.item.country }}</td>                                                                                         
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>            
    </v-row>  


    <v-snackbar
      v-model="errorbar"
    >
      An error has occurred/No filters found
      <v-btn
        color="pink"
        text
        @click="errorbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>    
  </v-container>
</template>

<script>
  import StrategyPerformanceChart from "@/components/StrategyPerformanceChart";
  import RollingExpoChart from "@/components/RollingExpoChart";
  export default {
    name: 'marketStrategy',
    components: {StrategyPerformanceChart,RollingExpoChart},
    data() {
      return {
        nbStocks:50,
        portfolioConstituents: [],
        portfolioConstituentsDate: null,
        selectConstituentsDate:null,
        portfolioListRebal: [], 
        
        selectedParams: {},        
        sectorExpo : null,
        countryExpo: null,
        stratReturn: null,
        stats:[],

        dateEnd:new Date().toISOString().substr(0, 10),
        menu3:false,
        menu2: false,     
        dateStart: null,   
        absolute: true,
        opacity: 0.46,
        overlay: false,        
        overlay2: false,
        sector: [],
        benchmark: [],
        country: [],
        countries :[],
        sectors:[],
        benchmarks:[],
        search: '',
        headers: [
          {
            sortable: false,
            text: '',
            align: 'left',
          },
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          { text: 'Ticker', value: 'ticker' },
          { text: 'RIC', value: 'ric' },
          { text: 'Weight', value: 'wgt', align: 'right' },
          { text: 'Sector', value: 'sector', align: 'right' },
          { text: 'Country', value: 'country', align: 'center' },
        ],
        items: [],
        listLoad: true,
        errorbar: false,
        buttonLoading: false,
      }
    },
    mounted () {
      this.getFiltersFromApi();
      this.getListFromApi(null);
      /* DATE START CALCULATION*/
      var d = new Date();
      d.setMonth(d.getMonth() - 3);
      this.dateStart = d.toISOString().substr(0, 10);
    },
    computed: {
      likesAllSectors () {
        return this.sector.length === this.sectors.length
      },
      likesSomeSectors () {
        return this.sector.length > 0 && !this.likesAllSectors
      },
      iconSector () {
        if (this.likesAllSectors) return 'mdi-close-box'
        if (this.likesSomeSectors) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },

      likesAllCountries () {
        return this.country.length === this.countries.length
      },
      likesSomeCountries () {
        return this.country.length > 0 && !this.likesAllCountries
      },
      iconCountry () {
        if (this.likesAllCountries) return 'mdi-close-box'
        if (this.likesSomeCountries) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
    
    },    
    methods: {
      toggleAllSector () {
        this.$nextTick(() => {
          if (this.likesAllSectors) {
            this.sector = []
          } else {
            this.sector = this.sectors.slice()
          }
        })
      },      
      toggleAllCountry () {
        this.$nextTick(() => {
          if (this.likesAllCountries) {
            this.country = []
          } else {
            this.country = this.countries.slice()
          }
        })
      },                 
      async getFiltersFromApi () {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.get(process.env.VUE_APP_API_HOST + '/get-strategy-filters',{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.countries= response.data.country
          self.sectors= response.data.sector
          self.benchmarks= response.data.benchmark
          self.listLoad = false
        }).catch(function () {
          self.listLoad = false
          self.errorbar = true
        })
      },
      getStockList(e) {
        e.preventDefault();        
        let bodyFilter = {
          sectors :this.sector,
          countries :this.country,
          benchmark :this.benchmark,
          dateStart: this.dateStart,
          dateEnd: this.dateEnd,
          nbStocks: this.nbStocks,
        }
        this.selectedParams = bodyFilter;          
        //console.log(bodyFilter)
        this.getListFromApi(bodyFilter)
        //this.overlay=false
      },            
      async getListFromApi(filter) {
        var self = this
        self.buttonLoading=true
        self.overlay=true        
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.post(process.env.VUE_APP_API_HOST + '/get-strategy-performance',filter,{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.sectorExpo = response.data.sectorExpo;
          self.countryExpo= response.data.countryExpo;
          self.stratReturn= response.data.return;
          //console.log(self.stratReturn)
          self.portfolioConstituents= response.data.constituents;
          self.portfolioConstituentsDate= response.data.constituentsDate;
          self.portfolioListRebal= response.data.rebalDates; 
          self.stats= response.data.stats;   


          self.listLoad = false
          self.buttonLoading=false
          self.overlay=false          
        }).catch(function (/*error*/) {
          //console.log(error)
          self.listLoad = false
          //self.errorbar = true
          self.buttonLoading=false
          self.overlay=false
        })
      },      
      analyzeStock (item) {
        this.$router.push({ path: `/stocks/analyze/${item}` })
      },
      updatePortfolioConstituentsAtDate() {
        this.getPortfolioFromApi(this.selectedParams)
      },
      async getPortfolioFromApi(filter) {
        var self = this
        this.overlay2=true
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.post(process.env.VUE_APP_API_HOST + '/get-strategy-performance/' + this.portfolioConstituentsDate, filter,{
            headers: {
              'Authorization': currentToken,
              'Content-Type': 'application/json'
            }
          }).then(function (response) {
            self.portfolioConstituents = response.data.constituents;
            self.portfolioConstituentsDate = response.data.constituentsDate;
            self.overlay2=false;
          }).catch(function (/*error*/) {
            self.errorbar= true;
            self.errorMessage= "An error has occurred/Could not locate any portfolio at that date";
            self.overlay2=false;
            self.portfolioConstituents=[]
            //console.log(error)  
          });
      },      
      resetSearchForm () {
        this.sector = []
        this.country = []
        this.benchmark = ''
        var d = new Date();
        d.setMonth(d.getMonth() - 3);
        this.dateStart = d.toISOString().substr(0, 10);        
        this.dateEnd=new Date().toISOString().substr(0, 10);
        this.nbStocks=50;
      }
    }
  }
</script>
